/**
 * User Manager - Now works with authentication context
 * Gets user ID from auth token or localStorage for backward compatibility
 */
class UserManager {
  constructor() {
    this.USER_ID_KEY = 'hearen_user_id';
    this.USER_DATA_KEY = 'hearen_user_data';
  }

  /**
   * Get user ID from auth token stored in localStorage
   * This is a helper for components that don't have access to useAuth hook
   */
  getUserId() {
    // Try to get from auth context first (will be set by login)
    const authToken = localStorage.getItem('auth_token');
    if (authToken) {
      try {
        // Decode JWT to get user ID
        const payload = JSON.parse(atob(authToken.split('.')[1]));
        return payload.sub;
      } catch (e) {
        console.error('Failed to decode auth token', e);
      }
    }
    
    // Fallback to old localStorage method (for backward compatibility)
    return localStorage.getItem(this.USER_ID_KEY);
  }

  /**
   * Clear user data (logout)
   */
  clearUserData() {
    localStorage.removeItem(this.USER_ID_KEY);
    localStorage.removeItem(this.USER_DATA_KEY);
    localStorage.removeItem('auth_token');
  }
}

const userManager = new UserManager();
export default userManager;
